export default {
    pending: {
        id: 1,
        text: 'Pendiente',
        type: 'danger'
    },
    approved: {
        id: 2,
        text: 'Aprobada',
        type: 'success'
    },
    rejected: {
        id: 3,
        text: 'Rechazada',
        type: 'error'
    },
    review: {
        id: 4,
        text: 'Revisar',
        type: 'info'
    },
    cancelled: {
        id: 5,
        text: 'Cancelada',
        type: 'dark'
    }
};
